interface Chain {
  chainId: number | string;
  code: string;
  standard: string;
  name: string;
  chainName: string;
  chainType: number;
  iconDayUrl: string;
  iconNightUrl: string;
  website: string;
  is0xStart: boolean;
  isRegisterNeedPubkey: boolean;
  dappGasFeeNeedBuildTransaction: boolean;
  baseTokenContract: string;
  isOneLevelGasFee: boolean;
  baseTokenName: string;
  getTxUrl(txHas: string): string;
  getAddressUrl(address: string): string;
}

/// STX链
export const STX: Chain = {
  chainId: 999999996,
  code: 'STX',
  name: 'STX',
  standard: 'STX',
  chainName: 'STX',
  chainType: 5,
  is0xStart: false,
  isRegisterNeedPubkey: true,
  dappGasFeeNeedBuildTransaction: true,
  baseTokenContract: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
  isOneLevelGasFee: false,
  baseTokenName: 'STX',
  iconDayUrl:
    'https://static.bymj.io/bhop/image/yjzZ2c091K3zrn7tef-l8TBneYAmri7fwECBOejMdkw.svg',
  iconNightUrl:
    'https://static.bymj.io/bhop/image/yjzZ2c091K3zrn7tef-l8TBneYAmri7fwECBOejMdkw.svg',
  website: 'https://explorer.hiro.so/',
  getTxUrl: (txHas) => `https://explorer.hiro.so/txid/${txHas}`,
  getAddressUrl: (address) => `https://explorer.hiro.so/address/${address}`,
};

/// APTOS链
export const APTOS: Chain = {
  chainId: 999999992,
  code: 'APT',
  name: 'Aptos',
  standard: 'BRC-20',
  chainName: 'Aptos',
  chainType: 6,
  is0xStart: true,
  isRegisterNeedPubkey: true,
  dappGasFeeNeedBuildTransaction: true,
  baseTokenContract: '0x1::aptos_coin::AptosCoin',
  isOneLevelGasFee: false,
  baseTokenName: 'APT',
  iconDayUrl:
    'https://static.bymj.io/bhop/image/PSxtIWecK4tCViFl5-0wOcc6-8dGJdLFKXv2zNmT5Eo.svg',
  iconNightUrl:
    'https://static.bymj.io/bhop/image/PSxtIWecK4tCViFl5-0wOcc6-8dGJdLFKXv2zNmT5Eo.svg',
  website: 'https://explorer.aptoslabs.com/',
  getTxUrl: (txHas) => `https://explorer.aptoslabs.com/txn/${txHas}`,
  getAddressUrl: (address) =>
    `https://explorer.aptoslabs.com/address/${address}`,
};

export const TON: Chain = {
  chainId: 999999991,
  code: 'TON',
  name: 'TON',
  chainName: 'TON',
  standard: 'ERC-20',
  chainType: 7,
  is0xStart: false,
  isRegisterNeedPubkey: true,
  dappGasFeeNeedBuildTransaction: false,
  baseTokenContract: 'EQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAM9c',
  isOneLevelGasFee: true,
  baseTokenName: 'TON',
  iconDayUrl:
    'https://static.bymj.io/bhop/image/R0Zm1PhDRKKYxMFrw5JiRxUHJS1dvNhFNHI8SZK2SE4.png',
  iconNightUrl:
    'https://static.bymj.io/bhop/image/R0Zm1PhDRKKYxMFrw5JiRxUHJS1dvNhFNHI8SZK2SE4.png',
  website: 'https://tonscan.org/',
  getTxUrl: (txHas) => `https://tonscan.org/tx/${txHas}`,
  getAddressUrl: (address) => `https://tonscan.org/address/${address}`,
};

/// BTC链
export const BITCOIN: Chain = {
  chainId: 999999999,
  code: 'BTC',
  name: 'BTC Native SegWit',
  standard: 'BRC-20',
  chainName: 'BTC Native SegWit',
  chainType: 4,
  is0xStart: false,
  isRegisterNeedPubkey: false,
  dappGasFeeNeedBuildTransaction: false,
  baseTokenContract: '',
  isOneLevelGasFee: false,
  baseTokenName: 'BTC',
  iconDayUrl:
    'https://static.bymj.io/bhop/image/ibm5vSdhoGYSqilD4z9gU7CDVnKu3zY606kQh5Rhbp0.svg',
  iconNightUrl:
    'https://static.bymj.io/bhop/image/LQ6suMVF2tqmOnBDyM4cPcpkrvboA6CNllWFbkwPAXc.svg',
  website: 'https://btcscan.org/',
  getTxUrl: (txHas) => `https://btcscan.org/tx/${txHas}`,
  getAddressUrl: (address) => `https://btcscan.org/address/${address}`,
};

/// SOL链
export const SOLANA: Chain = {
  chainId: 999999997,
  code: 'SOL',
  name: 'Solana',
  standard: 'solana',
  chainName: 'Solana',
  chainType: 3,
  is0xStart: false,
  isRegisterNeedPubkey: false,
  dappGasFeeNeedBuildTransaction: false,
  baseTokenContract: '',
  isOneLevelGasFee: true,
  baseTokenName: 'SOL',
  iconDayUrl:
    'https://static.bymj.io/bhop/image/bzK4i6tqUsF06QL5ntMHk2SjrC4bSA8jTN8z1OMOfVo.svg',
  iconNightUrl:
    'https://static.bymj.io/bhop/image/6X2z6aM6AblnSR4lKN2aALefyk1DdNBZJRBjvXsrRMo.svg',
  website: 'https://solscan.io/',
  getTxUrl: (txHas) => `https://solscan.io/tx/${txHas}`,
  getAddressUrl: (address) => `https://solscan.io/address/${address}`,
};

/// SUI链
export const SUI: Chain = {
  chainId: 999999998,
  code: 'SUI',
  name: 'SUI',
  standard: 'SUI',
  chainName: 'SUI',
  chainType: 2,
  is0xStart: true,
  isRegisterNeedPubkey: false,
  dappGasFeeNeedBuildTransaction: false,
  baseTokenContract: '0x2::sui::SUI',
  isOneLevelGasFee: false,
  baseTokenName: 'SUI',
  iconDayUrl:
    'https://static.bymj.io/bhop/image/vwxa8jMxoTQLdhV4ofTcuIEezVa5w1t8aK8kW27-2v8.svg',
  iconNightUrl:
    'https://static.bymj.io/bhop/image/vwxa8jMxoTQLdhV4ofTcuIEezVa5w1t8aK8kW27-2v8.svg',
  website: 'https://suiexplorer.com',
  getTxUrl: (txHas) => `https://suiexplorer.com/txblock/${txHas}`,
  getAddressUrl: (address) => `https://suiexplorer.com/address/${address}`,
};

/// ETH链
export const ETH: Chain = {
  chainId: 1,
  code: 'ETH',
  name: 'Ethereum',
  standard: 'ERC20',
  chainName: 'Ethereum',
  chainType: 1,
  is0xStart: true,
  isRegisterNeedPubkey: false,
  dappGasFeeNeedBuildTransaction: false,
  baseTokenContract: '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee',
  isOneLevelGasFee: false,
  baseTokenName: 'ETH',
  iconDayUrl: 'https://static.bymj.io/spot/web3/img/eth-chain.png',
  iconNightUrl: 'https://static.bymj.io/spot/web3/img/eth-chain.png',
  website: 'https://etherscan.io',
  getTxUrl: (txHas) => `https://etherscan.io/tx/${txHas}`,
  getAddressUrl: (address) => `https://etherscan.io/address/${address}`,
};
